<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="mat-elevation-z8">
            <div class="flex-row header-padding">
                <div class="orders-table-title">All Orders</div>
                <div class="filler"></div>
                <div class="flex gap-3">
                    <mat-form-field class="ml-4 mt-3 w-500px custom-search-field mt-search" appearance="fill">
                        <mat-icon matPrefix class="text-gray-500">
                            search
                        </mat-icon>
                        <input matInput type="text"
                               [(ngModel)]="filter.search"
                               (input)="handleFilterChange()"
                               placeholder="Search by order ID or store name" />
                    </mat-form-field>
                    <div class="flex h-45px gap-3 mt-1">
                        <div class="align-self-center orders-divider"></div>
                        <button mat-button class="filter-button" (click)="showFilter()">
                            <mat-icon>filter_alt</mat-icon>
                            <span class="button-filter-label">Filter</span>
                            <span *ngIf="filtersAppliedCount">({{filtersAppliedCount}})</span>
                        </button>
                        <button mat-button class="btn-orders btn-refresh" (click)="onReloadClick()">
                            <mat-icon>refresh</mat-icon>Refresh
                        </button>
                    </div>
                </div>
            </div>

        <div *ngIf="isSpinnerVisible" class="loading-container">
            <mat-spinner></mat-spinner>
            <p>Loading orders...</p>
        </div>

            <div *ngIf="!isSpinnerVisible && (!orders || orders.length === 0)" class="empty-table-container">
                <ng-container *ngIf="!isFilterApplied || !filtersAppliedCount">
                    <img src="../Content/xpress-app/images/svg/no-orders-no-filter.svg" class="mb-5" />
                    <div class="empty-table-text fw-6">Sorry we couldn't find any results</div>
                </ng-container>
                <ng-container *ngIf="isFilterApplied && filtersAppliedCount && (!orders || orders.length === 0)">
                    <img src="../Content/xpress-app/images/svg/no-orders-filter.svg" class="mb-3" />
                    <div class="empty-table-text fw-6">We didn't find a match</div>
                    <div class="empty-table-text fw-5">Try searching for something else.</div>
                </ng-container>
            </div>

        <table  [ngClass]="{'hidden': isSpinnerVisible}"
                mat-table
                [dataSource]="dataSource"
                matSort
                [matSortActive]="'Id'"
                [matSortDirection]="'desc'"
                (matSortChange)="onSortChange($event)"
                >

            <ng-container matColumnDef="Id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Id</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">{{element.Id}}</td>
            </ng-container>

            <ng-container matColumnDef="UserName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">{{element.UserName}}</td>
            </ng-container>

            <ng-container matColumnDef="OrderType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Type</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">{{element.OrderType}}</td>
            </ng-container>

            <ng-container matColumnDef="StoreName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Store</th>
                <td mat-cell *matCellDef="let element">{{element.StoreName}}</td>
            </ng-container>

            <ng-container matColumnDef="DeliveryDateFrom">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Pickup Time</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">{{element.DeliveryDateFrom}}</td>
            </ng-container>

            <ng-container matColumnDef="OrderDetails">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Items</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">{{element.OrderDetails}}</td>
            </ng-container>

            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngStyle]="getStatusStyles(element.Status)">{{element.Status}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="OrderAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
                <td class="cursor-pointer" (click)="openOrderViewDialog(element)" mat-cell *matCellDef="let element">{{element.OrderAmount}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

        <mat-paginator
                [length]="totalRecords"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="pageSizeOptions"
                (page)="onPageChange($event)"
                showFirstLastButtons
                *ngIf="!isSpinnerVisible && orders && orders.length > 0">
        </mat-paginator>
    </div>
</div>

<partner-orders-filter *ngIf="showFilterSidebar" [parent]="this"></partner-orders-filter>

<mart-order-details *ngIf="showOrderDetailsPopup"
                    [orderId]="editOrderId"
                    [onHide]="onOrderDetailsPopupHide"></mart-order-details>

<p-toast position="top-right"></p-toast>

<!--Dispute sidebar-->
<p-sidebar [(visible)]="showDisputeSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           [style]="{width:'535px'}">
    <ng-template pTemplate="header" class="filter-header filter-text-color">Dispute a refund</ng-template>

    <div class="flex mt-4">
        <div>
            <div *ngIf="!profile.ImageUrl" class="profile-avatar-empty dispute-avatar">
                <div class="pt-3 ml-2 fs-16">{{profile.FirstName}}{{profile.LastName}}</div>
            </div>
            <div *ngIf="profile.ImageUrl" >
                <img class="profile-avatar-empty dispute-avatar" src="{{profile.ImageUrl}}"/>
            </div>
        </div>

        <div class="ml-3 mt-2">
            <div class="flex">
                <div class="common-font-medium driver-name">{{profile.FirstName + ' ' + profile.LastName}}</div>
            </div>
            <div class="flex mt-1">
                <div class="mr-2">
                    <div class="date-value text-very-small">{{formattedDate}}</div>
                </div>
            </div>
        </div>
    </div>

    <hr>

    <div class="mt-3">
        <div class="dispute-rules-description">If you think the products refunded is incorrect, submit the details below and a</div>
        <div class="dispute-rules-description">member of our customer support team will investigate the issue. Please include</div>
        <div class="dispute-rules-description">any photos or videos you may have. Resolution time is approx 5 business days.</div>
    </div>

    <div class="flex flex-column mt-2">
        <div class="common-font-medium mt-3 mb-1">Select Products</div>
        <ng-container *ngFor="let missingProduct of products; let i = index;">
            <div class="ml-3 flex filter-elem-height">
                <input id="check{{i}}" type="checkbox" [checked]="false"
                       class="filter-checkbox" (change)="selectProduct(missingProduct)">
                <mat-label class="mt-3 ml-4 filter-value filter-text-color">{{missingProduct.ProductName}}</mat-label>
            </div>
        </ng-container>
    </div>

    <div class="flex flex-column mt-3">
        <mat-label class="common-font-medium mb-2 mt-1">Reason for Dispute</mat-label>
        <mat-select [placeholder]="'Select reason'" [(value)]="disputeReasonId">
            <mat-option class="mb-3" *ngFor="let disputeReason of disputeReasons" [value]="disputeReason.Id">
                {{ disputeReason.Name }}
            </mat-option>
        </mat-select>

        <textarea *ngIf="disputeReasonId === DisputeReasonEnum.Other" class="dispute-border mt-3" rows="5" cols="30"
                  [(ngModel)]="otherReason" placeholder="Please describe the dispute reason." pInputTextarea></textarea>
    </div>

    <div class="common-font-medium mt-4 mb-b">Description</div>
    <div class="flex flex-column mt-1">
        <textarea class="dispute-border" rows="5" cols="30" [value]="disputeDescription" placeholder="Please describe the reason for this decision." pInputTextarea></textarea>
    </div>

    <div class="common-font-medium mt-4 mb-2">Attachments</div>
    
    <!-- File upload area with dashed border -->
    <div (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onFileDrop($event)"
         class="upload-dashed mb-4">
        <p class="upload__hint">Drop files here to upload</p>
        <input type="file"
               class="upload__file-input"
               (change)="onFileSelected($event)"
               multiple
               accept=".jpg,.jpeg,.png,.heic,.heif,.mp4,.mov,.mkv,.avi"
               #fileUpload/>
        <button mat-button
                type="button"
                class="light-button"
                (click)="fileUpload.click()">
            Browse files
        </button>
    </div>

    <!-- Display attached files -->
    <div *ngIf="attachedFiles.length > 0" class="mb-4">
        <div class="common-font-medium mb-2">Attached Files:</div>
        <mat-chip-set aria-label="Attached files" class="filename-chip">
            <mat-chip *ngFor="let attachedFile of attachedFiles; let i = index" class="file-chip">
                {{ attachedFile.name }}
                <button (click)="removeAttachedFile(i)"
                        matChipRemove
                        aria-label="Remove file">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-chip>
        </mat-chip-set>
    </div>

    <ng-template pTemplate="footer" class="flex justify-content-end mt-4">
        <div class="flex justify-content-end">
            <button pButton class="btn-secondary filter-button" label="Cancel" (click)="closeDisputeSidebar()"></button>
            <button pButton class="btn-darkblue filter-button ml-3" label="Submit" [ngClass]="{'btn-disabled': isSubmitDisabled() }"
                    [disabled]="isSubmitDisabled()"
                    (click)="submitDisputeConfirmDialog = true"></button>
        </div>
    </ng-template>
</p-sidebar>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="discardConfirmDialog"
          [style]="{ 'width': '665px', 'height': '200px', 'border-radius': '28px', 'position': 'relative', 'z-index': '11022' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Discard changes?</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text">This will discard changes and cannot be reversed. Do you really</div>
        <div class="discard-text mb-5"> want to continue?</div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="btn-profile btn-danger-default mr-3" style="border-radius: 100px" (click)="discardConfirm()">Discard Changes</div>
        <div class="btn-profile btn-white btn-cancel" style="border: none" (click)="cancelDiscard()">Go Back</div>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="submitDisputeConfirmDialog"
          [style]="{ 'width': '665px', 'height': '200px', 'border-radius': '28px', 'position': 'relative', 'z-index': '11022' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Are you sure you want to submit a dispute?</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text">This action will close the dispute and cannot be undone.</div>
        <div class="discard-text mb-5">Are you sure you want to proceed?</div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="btn-profile btn-default mr-3" style="border-radius: 100px" (click)="submitDispute()">Submit</div>
        <div class="btn-profile btn-white btn-cancel" style="border: none" (click)="cancelSubmitDispute()">Go Back</div>
    </ng-template>
</p-dialog>
